module.exports = __webpack_public_path__ + "static/edit-content-above-description-249371115d2ebee92b4482371b308b4b.png";